import React from 'react'
import PropTypes from 'prop-types'

import { NavLink } from 'react-router-dom'

import Icon from '@components/icon/icon.component'

import useStyles from './list-item.style'

const ListItem = (props) => {
  const { onClick, title, subtitle, rightComponent, to } = props

  const classes = useStyles(props)

  return (
    <NavLink
      onClick={onClick}
      to={to}
    >
      <li className={classes.listItem}>
        <div className={classes.text}>
          <div className={classes.title}>{title}</div>
          <div className={classes.subtitle}>{subtitle}</div>
        </div>
        <div className={classes.rightComponentContainer}>{rightComponent}</div>
      </li>
    </NavLink>

  )
}

ListItem.defaultProps = {
  onClick: () => {},
  rightComponent: <Icon type='caret-right' />,
  title: '',
  to: '',
  subtitle: ''
}

ListItem.propTypes = {
  onClick: PropTypes.func,
  rightComponent: PropTypes.node,
  title: PropTypes.string,
  to: PropTypes.string,
  subtitle: PropTypes.string
}

export default ListItem
